import script from "./PrintModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintModal.vue?vue&type=script&setup=true&lang=js"

import "./PrintModal.vue?vue&type=style&index=0&id=36fc773b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fc773b"]])

export default __exports__